import { AbstractControl, ValidationErrors } from '@angular/forms';

export function trimmedRequiredValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (value === null || value === undefined || value === '') {
        return { required: true };
    }
    if (typeof value === 'string' && value.trim() === '') {
        return { required: true };
    }
    return null;
}
